const key = 'learning-at-kingston';

export default {
  rootNavKey: [key],
  parentKeys: [key],
};
